var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}]},_vm._l((_vm.filteredDiscounts),function(discount){return _c('div',{key:discount.id,staticClass:"c-box u-my-2"},[_c('div',{domProps:{"innerHTML":_vm._s(discount.content)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }